
























































import {Component, Vue} from '@/shared/component';
import {Stored} from "vue-stored-prop-decorator";
import {User} from '@/models';
import {ResultType} from "@/shared/xhttp";

import storeUser from '@/stores/modules/user';
import CrudVenteList from "@/components/Crud/Vente/List.vue";
import CrudVenteFilter from "@/components/Crud/Vente/Filter.vue";
import CrudVenteFilterTotauxVentes from "@/components/Crud/Vente/FilterTotauxVentes.vue";
import CrudVenteListTotauxVentes from "@/components/Crud/Vente/ListTotauxVentes.vue";

@Component({
	components: {
		CrudVenteFilter,
		CrudVenteFilterTotauxVentes,
		CrudVenteList,
		CrudVenteListTotauxVentes,
	}
})
export default class TableauDeBordVente extends Vue {

	//@Stored(() => storeCubageChantierRestant) cubageChantierRestants!: ResultType<CubageChantierRestant>;
	@Stored(() => storeUser) me!: User;

	public created(): void {
	//	storeCubageChantierRestant.state.filters.boisType = true;
	//	storeCubageChantierRestant.state.filters.boisQuality = true;
	//	storeCubageChantierRestant.state.filters.boisSize = true;
	//	storeCubageChantierRestant.state.filters.nullValue = false;
	//	storeCubageChantierRestant.state.filters.groupChantier = false;
	//	storeCubageChantierRestant.state.filters.chantier = null;

		//console.log("created");
	}

	public mounted(): void {
		//this.addEventDom(window, 'resize', () => this.$forceUpdate());
		//console.log("mounted");
	}

}
